
export interface ForgotPasswordBody {
  email: string
}

export interface forgotPasswordResponse {
  message: string
}
